/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import appsAndPages from './apps-and-pages'
import others from './others'
import chartsAndMaps from './charts-and-maps'
import uiElements from './ui-elements'
import formAndTable from './forms-and-table'
import questions from './questions'
import dbMovies from "./db-movies";
import dbMusic from "./db-music";
import games from "./games";
import strips from "./strips";
import feedback from "./feedback";
import finance from './finance'
import players from './players'
import content from './content'
import generator from './generator'
import admin from './admin'

// Array of sections
export default [...questions, ...games, ...strips, ...feedback, ...finance, ...players, ...content, ...generator, ...dbMovies, ...dbMusic, ...admin, ...dashboard, ...appsAndPages, ...uiElements, ...formAndTable, ...chartsAndMaps, ...others]
